import { getDomains } from './helpers'
import { homeRoutes } from 'subdomains/Home/routes'
import { adminRoutes } from 'subdomains/Admin/routes'
import { brettRoutes } from 'subdomains/Brett/routes'
import { andreaRoutes } from 'subdomains/Andrea/routes'
import { benRoutes } from 'subdomains/Ben/routes'
import { veraRoutes } from 'subdomains/Vera/routes'

const AppRoutes = [
  { ...homeRoutes },
  { ...adminRoutes },
  { ...brettRoutes },
  { ...andreaRoutes },
  { ...benRoutes },
  { ...veraRoutes },
]

export default function getRoutes() {
  const tophost = getDomains().shift()

  const subdomain =
    tophost === 'herrmann' || tophost === 'localhost' ? null : tophost

  let { routes } = AppRoutes.find(appRoute => appRoute.main)

  if (subdomain) {
    const route = AppRoutes.find(appRoute => appRoute.subdomain === subdomain)

    if (route) routes = route.routes
  }

  return routes
}